export default __webpack_public_path__ + "static/media/Instagram_logo_2016.bad96368.svg";